export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  code: string;
  id: number;
  clinicId: number;
  status: number;
  templateRange: string;
  templateName: string;
  templateUnit: string;
};

export type MasterDataType = {
  id: number;
  clinicId: number;
  status: number;
  code: string;
  templateRange: string;
  templateUnit: string;
  templateName: string;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  status: number;
  code: string;
  templateRange: string;
  templateUnit: string;
  templateName: string;
};

export const initialFormData: MasterFormDataType = {
  status: 1,
  code: "",
  templateRange: "",
  templateUnit: "",
  templateName: "",
};
